var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-form"},[(_vm.visible)?_c('avue-form',{ref:"form",attrs:{"option":_vm.formOption},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }